import React, { useState, FormEvent, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import Layout from "../components/layouts/Layout";
import PasswordField from "../components/PasswordField";
import TextField from "../components/TextField";
import ROUTES from "../setup/routes";
import { DispatchContext, StateContext } from "../store/context";
import Logo from "../static/logo.png";
import ErrorBoundary from "../components/ErrorBoundary";
import { useFetchApi } from "../hooks/useFetchApi";
import Alert from "../components/Alert";
import Loader from "../components/Loader";
import AuthScreenLayout from "../components/authScreens/authScreenLayout";
import { saveToSessionStorage } from "../utils/sessionStorageState";
import { UPDATE_USER } from "../store/types";
import { terminateUserSession } from "../services/session.service";
import { useAuth } from "../hooks/useAuth";

export const _h = "18";

const ManuallyCreatedUserUpdate: React.FC = (): React.ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [d, setD] = useState<any>({});
  const dispatch = useContext(DispatchContext);
  const handleSuccess = () => {
    navigate(ROUTES.LOGIN);
  };
  const { execute: executeAuth } = useAuth();

  const { authUser } = useContext(StateContext);

  const { execute, response, loading } = useFetchApi(
    "/api/updateManuallyCreatedUser",
    {},
    "PUT"
  );

  const handleLogout = async () => {
    try {
      const isTerminated: boolean = await terminateUserSession(
        authUser?.username
      );
      if (isTerminated) {
        localStorage.removeItem("token");
        localStorage.removeItem("is_first_login");
        localStorage.removeItem("is_manually_created");
        saveToSessionStorage({});
        dispatch({ type: UPDATE_USER, payload: null });
        navigate(ROUTES.LOGIN);
      }
    } catch (e: any) {
      console.log("Error", e.message);
    }
  };

  const handleChange = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;
    setD({ ...d, [id]: value });
  };

  const handleUpdateUser = (e: any) => {
    e.preventDefault();
    console.log("d", d);
    if (d["password"] !== d["confirmPassword"]) {
      dispatch({
        type: "UPDATE_ALERT",
        payload: { type: "error", message: "Passwords don't match" },
      });
      return;
    }

    const requestData = {
      ...d,
      id: authUser?.id,
      username: authUser?.username,
    };

    console.log("Request data:", requestData);
    execute(requestData);
  };

  useEffect(() => {
    console.log("re", response);
    if (response && response.status === "error") {
      dispatch({
        type: "UPDATE_ALERT",
        payload: { type: "error", message: response.message },
      });
    }
  }, [response]);

  useEffect(() => {
    const handleSuccessfulResponse = async () => {
      if (response && response.status === "success") {
        try {
          if (await executeAuth(authUser?.username)) {
            console.log("Token Refreshed");
          }
          navigate(`${ROUTES.DASHBOARD}/${ROUTES.OVERVIEW}`);
        } catch (error) {
          console.error("Error refreshing token:", error);
          navigate(`${ROUTES.DASHBOARD}/${ROUTES.OVERVIEW}`);
        }
      }
    };

    handleSuccessfulResponse();
  }, [response, executeAuth, authUser?.username, navigate]);

  return (
    <Layout preLogin>
      <Loader show={loading} />
      <AuthScreenLayout>
        <div className=" w-full md:w-10/12  p-8 flex flex-col justify-center items-center">
          <div className="w-full ">
            <div className="flex items-center justify-center mb-4">
              <img src={Logo} className="flex h-24 p-3" />
            </div>
            <ErrorBoundary />
            <h1 className="text-2xl font-bold text-gray-900 mb-2 !font-dm">
              Update Details
            </h1>
            <p className="text-gray-600 mb-4 font-dm">
              Please update details to proceed
            </p>
            <div className="mt-6">
              <div>
                <Alert />
                <form
                  onSubmit={handleUpdateUser}
                  className="space-y-6 overflow-y-auto "
                >
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium leading-6 text-gray-900 font-dm"
                    >
                      Email
                    </label>
                    <div className="mt-2">
                      <TextField
                        full
                        type="email"
                        id="email"
                        value={authUser?.email}
                        disabled
                        className=" bg-transparent border-[#CCCCCC] rounded-[8px] placeholder:text-[#CCCCCC] font-dm  h-[44px]"
                      />
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <div>
                      <label
                        htmlFor="password"
                        className="block text-sm font-medium leading-6 text-gray-900 font-dm"
                      >
                        Password <span className="text-red-500">*</span>
                      </label>
                      <div className="mt-2">
                        <PasswordField
                          full
                          id="password"
                          onChange={handleChange}
                          className=" bg-transparent border-[#CCCCCC] rounded-[8px] placeholder:text-[#CCCCCC] font-dm  h-[44px]"
                        />
                      </div>
                    </div>

                    <div>
                      <label
                        htmlFor="confirmPassword"
                        className="block text-sm font-medium leading-6 text-gray-900 font-dm"
                      >
                        Confirm password <span className="text-red-500">*</span>
                      </label>
                      <div className="mt-2">
                        <PasswordField
                          full
                          id="confirmPassword"
                          onChange={handleChange}
                          className=" bg-transparent border-[#CCCCCC] rounded-[8px] placeholder:text-[#CCCCCC] font-dm  h-[44px]"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="mobile_number"
                      className="block text-sm font-medium leading-6 text-gray-900 font-dm"
                    >
                      Mobile No. e.g. +94123456789
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-2">
                      <TextField
                        full
                        id="mobile_number"
                        onChange={handleChange}
                        className=" bg-transparent border-[#CCCCCC] rounded-[8px] placeholder:text-[#CCCCCC] font-dm  h-[44px]"
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="full_name"
                      className="block text-sm font-medium leading-6 text-gray-900 font-dm"
                    >
                      Full name
                    </label>
                    <div className="mt-2">
                      <TextField
                        full
                        id="full_name"
                        type="text"
                        onChange={handleChange}
                        className=" bg-transparent border-[#CCCCCC] rounded-[8px] placeholder:text-[#CCCCCC] font-dm  h-[44px]"
                      />
                    </div>
                  </div>

                  <div className="flex gap-2 w-[50%]">
                    <Button
                      disabled={loading}
                      type="submit"
                      variant="primary"
                      fontSize="large"
                      full
                      onClick={handleUpdateUser}
                    >
                      Update
                    </Button>
                    {/* <Button
                      variant="neutral"
                      fontSize="large"
                      full
                      onClick={handleLogout}
                    >
                      {t("signup.text.goBackToLoginBtn")}
                    </Button> */}
                  </div>
                </form>
              </div>
            </div>

            <p className="text-center text-sm text-gray-500 mt-8 font-dm">
              ©2025 Valueit. All rights reserved.
            </p>
          </div>
        </div>
      </AuthScreenLayout>
    </Layout>
  );
};

export default ManuallyCreatedUserUpdate;
